export default {
  batch_clientss: [],
  autocomplete_data : [],
  autocomplete_selected : {},
  batch_clients:[],
  selected_batch_clients : {},
  batch_clients_status:[]
}
